export default __webpack_public_path__ + "static/media/quotes.173d7847.svg";